<template>
  <div class="flex flex-col">
    <div class="flex flex-row">
      <p class="basis-1/3 font-bold text-xl text-center">Category</p>
      <p class="basis-1/3 font-bold text-xl text-center">Cost Type</p>
      <p class="basis-1/3 font-bold text-xl text-center">Line Items <span class="font-normal text-sm">(e.g. 1-5,8,11-13)</span></p>
    </div>
    <div
      v-for="(costType, index) in custCostTypes"
      :class="index % 2 == 0 ? 'bg-surface-100 dark:bg-surface-900' : ''"
      class="flex flex-row py-1 h-10 gap-3"
    >
      <p class="basis-1/3 text-center my-auto">{{ costType.name }}</p>
      <Select
        v-model="selectedCostTypes[index]"
        :options="['INSP', 'NONINSP', 'SUB']"
        class="w-full basis-1/3"
        label-class="self-center"
        showClear
      ></Select>
      <InputText v-model="lineItems[index]" class="basis-1/3" :invalid="invalidFields[index]"></InputText>
    </div>
  </div>
  <SubmitOptions submit-label="Load" class="mt-3" @submitted="validate" @cancelled="$emit('cancelled')"></SubmitOptions>
</template>

<script setup lang="ts">
import type { Code } from "@/types/Codes";

interface Props {
  custCostTypes: Code[];
}
const props = defineProps<Props>();

const selectedCostTypes = ref<string[]>(new Array(props.custCostTypes.length).fill(undefined));
const lineItems = ref<string[]>(new Array(props.custCostTypes.length).fill(""));
const invalidFields = ref<boolean[]>(new Array(props.custCostTypes.length).fill(false));

export type CategoryLoad = {
  category: Code;
  lineItems: Set<number>;
  costType: string;
};

const emit = defineEmits<{
  submitted: [CategoryLoad[]];
  cancelled: [];
}>();

const regexp = /^(\d+(-\d+)?)(,(\s*\d+(-\d+)?))*$/;
const validate = (): void => {
  const loadData: CategoryLoad[] = [];
  let invalidFieldExists = false;
  for (let i = 0; i < props.custCostTypes.length; i++) {
    invalidFields.value[i] = false;
    let lineItemsInput = lineItems.value[i];
    if (lineItemsInput.trim().length == 0) continue;
    if (!regexp.test(lineItemsInput)) {
      invalidFields.value[i] = true;
      invalidFieldExists = true;
    } else {
      const items: Set<number> = new Set();
      for (const part of lineItemsInput.split(",")) {
        if (part.includes("-")) {
          const [startStr, endStr] = part.split("-");
          const start = parseInt(startStr);
          const end = parseInt(endStr);
          if (isNaN(start) || isNaN(end) || start > end) {
            invalidFields.value[i] = true;
            invalidFieldExists = true;
            continue;
          }
          for (let i = start; i <= end; i++) items.add(i);
        } else {
          const num = parseInt(part.trim());
          if (isNaN(num)) {
            invalidFields.value[i] = true;
            invalidFieldExists = true;
            continue;
          }
          items.add(num);
        }
      }
      loadData.push({
        category: props.custCostTypes[i],
        lineItems: items,
        costType: selectedCostTypes.value[i],
      });
    }
  }

  if (invalidFieldExists) {
    error("Invalid Item Range", "Draw item ranges not formatted properly");
  } else {
    emit("submitted", loadData);
  }
};
</script>
